// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__zMYCs"};